import React from "react";
import Tooltip from "../components/Tooltip";

// Source of truth for the tier-meaning tooltip.
// Keep this in sync with `CUSTOMER_TIERS` in /app/backend/app/constants.py.
export const TIER_LEGEND = [
  { n: 1, meaning: "Current Loyal Customer - uses us exclusively, gives recommendations, develop case study." },
  { n: 2, meaning: "Uses some of our equipment - Account Growing - good relationship." },
  { n: 3, meaning: "Uses some of our equipment - Account Declining - prickly relationship." },
  { n: 4, meaning: "Uses competitor - will not take calls - poor experience." },
  { n: 5, meaning: "Bad financial risk - No need for product." },
  { n: 6, meaning: "Have not made contact." },
];

export function TierTooltip({ testId = "tier-tooltip" }) {
  return (
    <Tooltip
      testId={testId}
      content={
        <div>
          <div className="font-semibold mb-1.5">Customer Tier key</div>
          <ol className="space-y-1 list-none pl-0">
            {TIER_LEGEND.map(t => (
              <li key={t.n}>
                <span className="inline-block w-4 font-semibold">{t.n}.</span>
                <span className="ml-1">{t.meaning}</span>
              </li>
            ))}
          </ol>
        </div>
      }
    />
  );
}
